import VueRouter from 'vue-router'
import Blank from '@/views/Blank'
import Home from '@/views/Home'
import TrialRequest from '@/views/TrialRequest'
import PrivacyPolicy from '@/views/PrivacyPolicy'
import Eula from '@/views/Eula'
import AboutUs from '@/views/AboutUs'
import ContactUs from '@/views/ContactUs'
import Application from '@/views/Application'

const routes =
[
    { path: '/blank', component: Blank, name: 'Blank' },
    { path: '/trial-request', component: TrialRequest, name: 'TrialRequest' },
    { path: '/privacy-policy', component: PrivacyPolicy, name: 'PrivacyPolicy', meta: { menuBarAlwaysLight: true } },
    { path: '/eula', component: Eula, name: 'Eula', meta: { menuBarAlwaysLight: true } },
    { path: '/about-us', component: AboutUs, name: 'AboutUs', meta: { menuBarAlwaysLight: true } },
    { path: '/contact-us', component: ContactUs, name: 'ContactUs', meta: { menuBarAlwaysLight: true } },
    { path: '/application/:appBundleId', component: Application, name: 'Application', meta: { hideMenuBar: true } },
    { path: '/', component: Home, name: 'Home' },
]

const router = new VueRouter
({
    routes,
    mode: 'history'
})

export default router


// WEBPACK FOOTER //
// ./src/router.js